import * as actionType from './actions/tpvAction';

const initialState = {
    list: [],
    message: '',
    modalOpen: false,
    loading: false,
    isTpvAuditEdit: false,
    isTpvAuditList: true,
    isTpvAuditCreate: false,
    isTpvNCList:false,
    apiStatus:false,
}

const tpvReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionType.GET_TPV_AUDIT_LIST:
            return { ...state, modalOpen: false,isTpvAuditList:true,isTpvAuditEdit:false,isTpvAuditCreate:false, message: "", TpvAuditData: action.payload }
        case actionType.GET_TPV_NC_LIST:
            return { ...state, modalOpen: false,isTpvNCList:true, message: "", TpvNcViewList: action.payload }   
        case actionType.API_CALL_STATUS:
            return { ...state, loading: action.payload.loading, apiStatus:action.payload.apiStatus, modalOpen: action.payload.modalOpen, message: action.payload.message, formattedNUpdateNC: action.payload.formattedNUpdateNC !=undefined? action.payload.formattedNUpdateNC : null}
        case actionType.IS_AUDITOR_PLAN_LIST:
            return { ...state, modalOpen:false, isAuditorPlanList: action.payload }
        default:
            return state
    }
}

export default tpvReducer;